<template>
  <div
    class="h-full flex flex-col font-sans text-[#1d1d1f] dark:text-[#f5f5f7] bg-[#F5F5F7] dark:bg-black p-2 sm:p-4 md:p-6 overflow-hidden relative">

    <header class="flex flex-col gap-3 mb-4 sticky top-0 z-30 shrink-0">

      <div class="flex flex-col md:flex-row items-center justify-between gap-3">
        <div
          class="flex items-center justify-between w-full md:w-auto bg-white/80 dark:bg-[#1c1c1e]/80 backdrop-blur-xl p-1.5 rounded-[16px] shadow-sm border border-black/5 dark:border-white/10">
          <div class="flex items-center">
            <button @click="changeMonth(-1)"
              class="p-2 rounded-lg text-[#86868b] hover:bg-black/5 dark:hover:bg-white/10 transition-colors">
              <span class="material-symbols-outlined text-[20px]">chevron_left</span>
            </button>
            <button @click="goToToday"
              class="px-3 py-1 text-[13px] font-semibold text-[#7B2CBF] dark:text-[#9D4EDD] hover:bg-black/5 dark:hover:bg-white/10 rounded-lg transition-colors">
              Hoje
            </button>
            <button @click="changeMonth(1)"
              class="p-2 rounded-lg text-[#86868b] hover:bg-black/5 dark:hover:bg-white/10 transition-colors">
              <span class="material-symbols-outlined text-[20px]">chevron_right</span>
            </button>
          </div>

          <div class="h-4 w-px bg-black/10 dark:bg-white/10 mx-1 hidden md:block"></div>

          <div class="relative flex-1 md:flex-none flex justify-center" ref="pickerRef">
            <button @click="openPicker = !openPicker"
              class="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-black/5 dark:hover:bg-white/10 transition-colors">
              <span class="text-[15px] font-bold tracking-tight capitalize truncate">
                {{ monthNames[currentMonth] }} {{ currentYear }}
              </span>
              <span class="material-symbols-outlined text-[16px] text-[#86868b] transition-transform duration-300"
                :class="openPicker ? 'rotate-180' : ''">
                expand_more
              </span>
            </button>

            <transition name="scale-fade">
              <div v-if="openPicker"
                class="absolute top-full right-0 md:left-0 mt-2 w-[280px] bg-white/95 dark:bg-[#2c2c2e]/95 backdrop-blur-2xl rounded-[18px] shadow-2xl p-3 grid grid-cols-3 gap-1 ring-1 ring-black/5 dark:ring-white/10 z-50">
                <button v-for="(m, i) in monthNames" :key="m" @click="setMonth(i)"
                  class="px-2 py-2.5 rounded-[10px] text-[13px] font-medium transition-colors"
                  :class="i === currentMonth ? 'bg-[#7B2CBF] text-white shadow-md' : 'text-[#1d1d1f] dark:text-[#f5f5f7] hover:bg-black/5 dark:hover:bg-white/10'">
                  {{ m.slice(0, 3) }}
                </button>
                <div
                  class="col-span-3 flex items-center justify-between pt-2 px-2 border-t border-black/5 dark:border-white/5 mt-1">
                  <button @click="currentYear--" class="p-1 hover:bg-black/5 dark:hover:bg-white/10 rounded">
                    <span class="material-symbols-outlined text-[16px]">chevron_left</span>
                  </button>
                  <span class="text-xs font-semibold">{{ currentYear }}</span>
                  <button @click="currentYear++" class="p-1 hover:bg-black/5 dark:hover:bg-white/10 rounded">
                    <span class="material-symbols-outlined text-[16px]">chevron_right</span>
                  </button>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div class="flex gap-2 w-full md:w-auto">
          <div class="relative flex-1 md:w-64">
            <span
              class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[#86868b] text-[18px]">search</span>
            <input v-model.trim="q" type="search" placeholder="Buscar..."
              class="w-full pl-9 pr-3 h-10 rounded-[14px] bg-white dark:bg-[#1c1c1e] border border-black/5 dark:border-white/10 text-[14px] placeholder-[#86868b] focus:ring-2 focus:ring-[#7B2CBF]/70 outline-none transition-all shadow-sm" />
          </div>

          <div class="flex bg-[#e3e3e8] dark:bg-[#2c2c2e] p-1 rounded-[14px] shrink-0">
            <button @click="viewMode = 'month'"
              class="p-2 rounded-[10px] transition-all flex items-center justify-center"
              :class="viewMode === 'month' ? 'bg-white dark:bg-[#636366] shadow-sm text-[#240046] dark:text-white' : 'text-[#86868b] hover:text-black dark:hover:text-white'">
              <span class="material-symbols-outlined text-[20px]">calendar_view_month</span>
            </button>
            <button @click="viewMode = 'list'"
              class="p-2 rounded-[10px] transition-all flex items-center justify-center"
              :class="viewMode === 'list' ? 'bg-white dark:bg-[#636366] shadow-sm text-[#240046] dark:text-white' : 'text-[#86868b] hover:text-black dark:hover:text-white'">
              <span class="material-symbols-outlined text-[20px]">view_agenda</span>
            </button>
          </div>
        </div>
      </div>

      <div
        class="flex bg-[#e3e3e8] dark:bg-[#2c2c2e] p-1 rounded-[14px] w-full overflow-x-auto no-scrollbar shadow-inner gap-1">
        <button @click="toggleType('gasto')"
          class="flex-1 px-3 py-2 rounded-[10px] text-[12px] sm:text-[13px] font-medium transition-all duration-300 flex items-center justify-center gap-1.5 whitespace-nowrap min-w-fit"
          :class="filters.gasto ? 'bg-white dark:bg-[#636366] text-[#240046] dark:text-white shadow-sm' : 'text-[#86868b] hover:text-black dark:hover:text-white'">
          <span class="w-2 h-2 rounded-full bg-rose-500 shrink-0"></span> Gastos
        </button>
        <button @click="toggleType('gastoCartao')"
          class="flex-1 px-3 py-2 rounded-[10px] text-[12px] sm:text-[13px] font-medium transition-all duration-300 flex items-center justify-center gap-1.5 whitespace-nowrap min-w-fit"
          :class="filters.gastoCartao ? 'bg-white dark:bg-[#636366] text-[#240046] dark:text-white shadow-sm' : 'text-[#86868b] hover:text-black dark:hover:text-white'">
          <span class="w-2 h-2 rounded-full bg-orange-500 shrink-0"></span> Cartão
        </button>
        <button @click="toggleType('tarefa')"
          class="flex-1 px-3 py-2 rounded-[10px] text-[12px] sm:text-[13px] font-medium transition-all duration-300 flex items-center justify-center gap-1.5 whitespace-nowrap min-w-fit"
          :class="filters.tarefa ? 'bg-white dark:bg-[#636366] text-[#240046] dark:text-white shadow-sm' : 'text-[#86868b] hover:text-black dark:hover:text-white'">
          <span class="w-2 h-2 rounded-full bg-blue-500 shrink-0"></span> Tarefas
        </button>
      </div>

    </header>

    <div class="flex flex-1 gap-6 min-h-0 relative">
      <div
        class="flex-1 flex flex-col bg-white dark:bg-[#1c1c1e] rounded-[20px] md:rounded-[24px] shadow-sm border border-black/5 dark:border-white/5 overflow-hidden relative">
        <transition name="fade" mode="out-in">

          <div v-if="viewMode === 'month'" key="month" class="flex flex-col h-full">
            <div class="grid grid-cols-7 border-b border-[#e5e5ea] dark:border-[#38383a]">
              <div v-for="dayName in weekDays" :key="dayName.long"
                class="py-2 sm:py-3 text-center text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-[#86868b]">
                <span class="sm:hidden">{{ dayName.short.charAt(0) }}</span>
                <span class="hidden sm:inline">{{ dayName.short }}</span>
              </div>
            </div>

            <div
              class="flex-1 grid grid-cols-7 grid-rows-5 lg:grid-rows-auto bg-[#F5F5F7] dark:bg-black gap-px border-b border-[#e5e5ea] dark:border-[#38383a]">
              <div v-for="day in monthGrid" :key="day.fullDate"
                class="bg-white dark:bg-[#1c1c1e] relative group transition-colors min-h-[60px] sm:min-h-[100px] flex flex-col items-center sm:items-stretch pt-1 sm:pt-1.5 sm:px-1.5"
                :class="{ 'opacity-50 grayscale': day.isPlaceholder }" @click="selectDay(day)" @dragover.prevent
                @drop="handleDrop(day, $event)">
                <div class="flex justify-center sm:justify-center mb-1 w-full">
                  <span
                    class="h-6 w-6 sm:h-7 sm:w-7 flex items-center justify-center rounded-full text-[12px] sm:text-[14px] font-medium transition-all"
                    :class="[
                      day.isToday ? 'bg-[#7B2CBF] text-white font-bold shadow-md' : 'text-[#1d1d1f] dark:text-[#f5f5f7]',
                      !day.isToday && !day.isPlaceholder ? 'group-hover:bg-black/5 dark:group-hover:bg-white/10' : ''
                    ]">
                    {{ day.dayNumber }}
                  </span>
                </div>

                <div class="flex flex-wrap justify-center gap-1 w-full px-0.5 sm:hidden">
                  <div v-for="event in day.events.slice(0, 4)" :key="'dot-' + event.id" class="w-1.5 h-1.5 rounded-full"
                    :class="event.appleDotColor"></div>
                  <span v-if="day.events.length > 4" class="text-[8px] text-[#86868b] leading-none">+</span>
                </div>

                <div class="hidden sm:block space-y-[3px] overflow-hidden w-full">
                  <div v-for="event in day.events.slice(0, 3)" :key="event.id"
                    class="rounded-[4px] shadow-sm transition-transform hover:scale-[1.02] cursor-grab active:cursor-grabbing px-1.5 py-0.5 w-full"
                    :class="[event.appleColor, day.isPast ? 'opacity-60 grayscale-[0.3]' : '']" draggable="true"
                    @dragstart="handleDragStart($event, event)">
                    <p class="truncate text-[10px] font-semibold leading-[16px] text-white">
                      {{ event.title }}
                    </p>
                  </div>
                  <div v-if="day.events.length > 3" class="pl-1">
                    <span class="text-[10px] font-medium text-[#86868b]">
                      +{{ day.events.length - 3 }} mais
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else key="list" class="h-full overflow-y-auto custom-scroll p-3 sm:p-4">
            <div v-if="!eventsInMonth.length" class="h-full flex flex-col items-center justify-center text-[#86868b]">
              <span class="material-symbols-outlined text-4xl mb-2 opacity-20">event_busy</span>
              <p>Nada agendado para este mês.</p>
            </div>

            <div class="space-y-6 max-w-4xl mx-auto pb-20 sm:pb-0">
              <div v-for="(group, dateKey) in groupedEventsByDate" :key="dateKey">
                <h3
                  class="sticky top-0 bg-white/95 dark:bg-[#1c1c1e]/95 backdrop-blur py-3 text-[13px] font-bold text-[#9D4EDD] uppercase tracking-wide border-b border-[#e5e5ea] dark:border-[#38383a] mb-2 z-10 flex items-center gap-2">
                  <span class="material-symbols-outlined text-[18px]">calendar_today</span>
                  {{ formatDateHeader(dateKey) }}
                </h3>
                <div
                  class="bg-[#F5F5F7] dark:bg-[#2c2c2e] rounded-[16px] overflow-hidden divide-y divide-[#e5e5ea] dark:divide-[#38383a]">
                  <div v-for="event in group" :key="event.id"
                    class="p-3 sm:p-4 flex items-center gap-3 sm:gap-4 hover:bg-black/5 dark:hover:bg-white/5 transition-colors group">
                    <div class="h-10 w-10 rounded-[10px] flex items-center justify-center text-white shadow-sm shrink-0"
                      :class="event.appleIconBg">
                      <span v-if="!event.logoUrl" class="material-symbols-outlined text-[20px]">{{ event.icon }}</span>
                      <img v-else :src="event.logoUrl"
                        class="h-full w-full object-contain rounded-[10px] bg-white p-1" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center gap-2 mb-0.5">
                        <h4
                          class="text-[14px] sm:text-[15px] font-semibold text-[#1d1d1f] dark:text-white leading-tight truncate">
                          {{ event.title }}
                        </h4>
                        <span v-if="event.type === 'gastoCartao'"
                          class="px-1.5 py-0.5 rounded text-[9px] font-bold bg-orange-500/10 text-orange-600 dark:text-orange-400 uppercase tracking-wide whitespace-nowrap">
                          Fatura
                        </span>
                      </div>
                      <p class="text-[12px] sm:text-[13px] text-[#86868b] truncate">
                        {{ event.description }}
                      </p>
                    </div>

                    <div class="flex gap-2 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
                      <button @click="addToGoogleCalendar(event)"
                        class="text-[11px] font-semibold text-[#1d1d1f] dark:text-white bg-[#F5F5F7] dark:bg-[#3a3a3c] lg:bg-white px-3 py-1.5 rounded-lg shadow-sm hover:scale-105 transition-transform flex items-center gap-1">
                        <img src="@/assets/google.png" class="w-3 h-3" /> Google
                      </button>
                      <button @click="addToAppleCalendar(event)"
                        class="text-[11px] font-semibold text-[#1d1d1f] dark:text-white bg-[#F5F5F7] dark:bg-[#3a3a3c] lg:bg-white px-3 py-1.5 rounded-lg shadow-sm hover:scale-105 transition-transform flex items-center gap-1">
                        <img src="@/assets/apple.png" class="w-3 h-3" /> Apple
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <transition name="slide-up-mobile">
        <div v-if="selectedDay"
          class="fixed inset-0 z-50 lg:absolute lg:top-4 lg:bottom-4 lg:right-4 lg:left-auto lg:w-[340px] bg-[#F5F5F7] dark:bg-black lg:bg-white/90 lg:dark:bg-[#1c1c1e]/90 backdrop-blur-2xl lg:rounded-[24px] lg:shadow-2xl lg:border lg:border-white/20 dark:lg:border-white/10 flex flex-col overflow-hidden">
          <div
            class="p-4 sm:p-5 border-b border-[#e5e5ea] dark:border-[#38383a] flex justify-between items-start bg-white dark:bg-[#1c1c1e] lg:bg-transparent shadow-sm lg:shadow-none shrink-0">
            <div>
              <p class="text-[11px] font-bold uppercase tracking-wider text-[#9D4EDD] mb-1">
                {{ selectedDay.date.toLocaleDateString('pt-BR', { weekday: 'long' }) }}
              </p>
              <h2 class="text-[28px] font-bold text-[#1d1d1f] dark:text-white leading-none">
                {{ selectedDay.dayNumber }}
              </h2>
              <p class="text-[13px] text-[#86868b] mt-1">
                {{ monthNames[currentMonth] }} {{ currentYear }}
              </p>
            </div>
            <button @click="selectedDay = null"
              class="h-8 w-8 rounded-full bg-[#e3e3e8] dark:bg-[#3a3a3c] flex items-center justify-center text-[#86868b] hover:text-[#1d1d1f] dark:hover:text-white transition-colors">
              <span class="material-symbols-outlined text-[20px]">close</span>
            </button>
          </div>

          <div class="flex-1 overflow-y-auto custom-scroll p-4 space-y-3">
            <div v-if="!selectedDay.events.length"
              class="h-full flex flex-col items-center justify-center text-center opacity-40">
              <div class="h-16 w-16 rounded-full bg-black/5 dark:bg-white/5 grid place-items-center mb-3">
                <span class="material-symbols-outlined text-3xl">event_available</span>
              </div>
              <p class="text-sm font-medium">Nenhum evento</p>
            </div>

            <div v-for="event in selectedDay.events" :key="event.id"
              class="bg-white dark:bg-[#1c1c1e] lg:bg-[#F5F5F7] lg:dark:bg-[#2c2c2e] p-4 rounded-[18px] shadow-sm lg:shadow-none border border-black/5 dark:border-white/5 lg:border-transparent lg:hover:border-black/5 dark:lg:hover:border-white/10 transition-all group relative overflow-hidden">
              <div class="flex items-start gap-3 relative z-10">
                <div class="h-10 w-10 rounded-[12px] flex items-center justify-center text-white shadow-sm shrink-0"
                  :class="event.appleIconBg">
                  <img v-if="event.logoUrl" :src="event.logoUrl"
                    class="w-full h-full object-contain rounded-[12px] bg-white p-1" />
                  <span v-else class="material-symbols-outlined text-[20px]">{{ event.icon }}</span>
                </div>
                <div class="flex-1 min-w-0 pt-0.5">
                  <h4 class="text-[14px] font-bold text-[#1d1d1f] dark:text-white leading-tight mb-0.5 break-words">
                    {{ event.title }}
                  </h4>
                  <p class="text-[12px] text-[#86868b] leading-relaxed break-words">
                    {{ event.description }}
                  </p>
                </div>
              </div>

              <div class="flex justify-end gap-2 mt-4 pt-3 border-t border-black/5 dark:border-white/5">
                <button @click="addToGoogleCalendar(event)"
                  class="text-[11px] font-semibold text-[#1d1d1f] dark:text-white bg-[#F5F5F7] dark:bg-[#3a3a3c] lg:bg-white px-3 py-1.5 rounded-lg shadow-sm hover:scale-105 transition-transform flex items-center gap-1">
                  <img src="@/assets/google.png" class="w-3 h-3" /> Google
                </button>
                <button @click="addToAppleCalendar(event)"
                  class="text-[11px] font-semibold text-[#1d1d1f] dark:text-white bg-[#F5F5F7] dark:bg-[#3a3a3c] lg:bg-white px-3 py-1.5 rounded-lg shadow-sm hover:scale-105 transition-transform flex items-center gap-1">
                  <img src="@/assets/apple.png" class="w-3 h-3" /> Apple
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import axios from 'axios'
import ical from 'ical-generator'

const gastos = ref([])
const tarefas = ref([])
const gastosCartao = ref([])
const viewMode = ref('month')
const apiBaseUrl = 'https://backend.controlease.com.br'
const today = new Date()
today.setHours(0, 0, 0, 0)
const currentYear = ref(today.getFullYear())
const currentMonth = ref(today.getMonth())
const selectedDay = ref(null)
const openPicker = ref(false)
const pickerRef = ref(null)
const q = ref('')
const filters = ref({ gasto: true, gastoCartao: true, tarefa: true })

const weekDays = [
  { short: 'DOM', long: 'Domingo' },
  { short: 'SEG', long: 'Segunda' },
  { short: 'TER', long: 'Terça' },
  { short: 'QUA', long: 'Quarta' },
  { short: 'QUI', long: 'Quinta' },
  { short: 'SEX', long: 'Sexta' },
  { short: 'SÁB', long: 'Sábado' }
]
const monthNames = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
]

const typeColors = {
  gasto: { pill: 'bg-rose-500', dot: 'bg-rose-500', iconBg: 'bg-rose-500' },
  tarefa: { pill: 'bg-blue-500', dot: 'bg-blue-500', iconBg: 'bg-blue-500' },
  gastoCartao: { pill: 'bg-orange-500', dot: 'bg-orange-500', iconBg: 'bg-orange-500' }
}

const bankLogos = {
  Santander: 'https://assets.hgbrasil.com/finance/companies/big/santander-br.png',
  Nubank: 'https://logodownload.org/wp-content/uploads/2019/08/nubank-logo-2-1.png',
  'Banco do Brasil': 'https://logopng.com.br/logos/banco-do-brasil-5.png',
  'C6 Bank': 'https://www.jornalcontabil.com.br/wp-content/uploads/2019/11/c6-1200x1200.png',
  Itaú: 'https://upload.wikimedia.org/wikipedia/commons/2/2d/2023_Ita%C3%BA_Unibanco_Logo.png',
  Bradesco: 'https://logodownload.org/wp-content/uploads/2018/09/bradesco-logo-4.png',
  Caixa: 'https://www.freepnglogos.com/uploads/logo-caixa-png/caixa-download-png-5.png',
  Inter: 'https://yt3.googleusercontent.com/c_fQMiJzVdFb80Mr79X5pJzLw2VoFtVab3fLLcUqJzpe-cmNti04vLsQ7bDVGcpHa0UMlrjg-KU=s900-c-k-c0x00ffffff-no-rj',
  PagBank: 'https://yt3.googleusercontent.com/dhhzAXfQDqT4ubXWVCcxRCT5WE6AvmZjARlYrMwmfel8WvLcqNSKdl4Ijya9m73UVIoIyZeV=s900-c-k-c0x00ffffff-no-rj',
  PicPay: 'https://play-lh.googleusercontent.com/pTvc9kCumx_24eJDwGUpvcBwljcIBkrsL3qHwhBW2NalMQ-XxTtHRV9YAJanBxkV0Rw',
  'Mercado Pago': 'https://cdn.shopify.com/app-store/listing_images/4f3dc60a0ef8beee2a168713fe20181f/icon/CIHzwOjZsI0DEAE=.png',
  Renner: 'https://logodownload.org/wp-content/uploads/2014/07/renner-logo-6.png',
  Amazon: 'https://images.icon-icons.com/1195/PNG/512/1490889698-amazon_82521.png',
  Shopee: 'https://logospng.org/download/shopee/logo-shopee-icon-1024.png',
  Outro: 'https://w7.pngwing.com/pngs/52/580/png-transparent-bank-account-computer-icons-bank-text-payment-logo.png'
}

const authConfig = () => {
  const token = localStorage.getItem('token')
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
}

const matchesQuery = e => {
  if (!q.value) return true
  const s = (q.value || '').toLowerCase()
  return (
    (e.title || '').toLowerCase().includes(s) ||
    (e.description || '').toLowerCase().includes(s)
  )
}

const allEvents = computed(() => {
  const processEvent = (item, type, icon, defaultColorKey) => {
    const appleColor = typeColors[defaultColorKey].pill
    const appleDot = typeColors[defaultColorKey].dot
    const appleIconBg = typeColors[defaultColorKey].iconBg

    return {
      id: `${type}-${item.id}`,
      date: new Date(`${item.dataPagamento || item.data}T12:00:00`),
      title: item.descricao || item.nome,
      description: type === 'gastoCartao'
        ? `Parcela ${item.numeroParcela}/${item.totalParcelas} • R$ ${Number(item.valorParcela).toFixed(2)}`
        : item.descricao || `R$ ${Number(item.valor).toFixed(2)}`,
      type,
      icon,
      appleColor,
      appleDotColor: appleDot,
      appleIconBg,
      logoUrl: item.banco ? bankLogos[item.banco] || bankLogos.Outro : null,
      originalObject: item
    }
  }

  const list = [
    ...gastos.value.map(g => processEvent(g, 'gasto', 'receipt_long', 'gasto')),
    ...tarefas.value.map(t => processEvent(t, 'tarefa', 'check_circle', 'tarefa')),
    ...gastosCartao.value.map(gc => processEvent(gc, 'gastoCartao', 'credit_card', 'gastoCartao'))
  ]

  return list.filter(e => filters.value[e.type]).filter(matchesQuery)
})

const eventsInMonth = computed(() => {
  return allEvents.value
    .filter(e => e.date.getFullYear() === currentYear.value && e.date.getMonth() === currentMonth.value)
    .sort((a, b) => a.date - b.date)
})

const groupedEventsByDate = computed(() => {
  const groups = {}
  eventsInMonth.value.forEach(e => {
    const key = e.date.toISOString().split('T')[0]
    if (!groups[key]) groups[key] = []
    groups[key].push(e)
  })
  return groups
})

const monthGrid = computed(() => {
  const days = []
  const firstDay = new Date(currentYear.value, currentMonth.value, 1).getDay()
  const daysInMonth = new Date(currentYear.value, currentMonth.value + 1, 0).getDate()

  for (let i = 0; i < firstDay; i += 1) {
    days.push({ isPlaceholder: true, fullDate: `ph-${i}`, events: [] })
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = new Date(currentYear.value, currentMonth.value, day)
    date.setHours(0, 0, 0, 0)
    const fullDateStr = date.toISOString().split('T')[0]

    days.push({
      dayNumber: day,
      fullDate: fullDateStr,
      date,
      isToday: date.getTime() === today.getTime(),
      isPast: date < today,
      isSelected: selectedDay.value?.fullDate === fullDateStr,
      events: allEvents.value.filter(e => e.date.toISOString().split('T')[0] === fullDateStr)
    })
  }
  return days
})

const fetchAllData = async () => {
  try {
    const [gRes, tRes, gcRes] = await Promise.all([
      axios.get(`${apiBaseUrl}/gastos`, authConfig()),
      axios.get(`${apiBaseUrl}/tarefas`, authConfig()),
      axios.get(`${apiBaseUrl}/gastos-cartao`, authConfig())
    ])
    gastos.value = gRes.data
    tarefas.value = tRes.data
    gastosCartao.value = gcRes.data
  } catch (err) {
    console.error(err)
  }
}

const changeMonth = dir => {
  const d = new Date(currentYear.value, currentMonth.value + dir, 1)
  currentMonth.value = d.getMonth()
  currentYear.value = d.getFullYear()
  selectedDay.value = null
}

const goToToday = () => {
  currentYear.value = today.getFullYear()
  currentMonth.value = today.getMonth()
  setTimeout(() => {
    const d = monthGrid.value.find(day => day.isToday)
    if (d) selectDay(d)
  }, 100)
}

const setMonth = i => {
  currentMonth.value = i
  openPicker.value = false
}

const selectDay = day => {
  if (!day.isPlaceholder) selectedDay.value = day
}

const toggleType = k => {
  filters.value[k] = !filters.value[k]
}

const formatDateHeader = iso => {
  const d = new Date(`${iso}T12:00:00`)
  return d.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })
}

const handleDragStart = (ev, item) => {
  ev.dataTransfer.setData('id', item.id)
}

const handleDrop = async (day, ev) => {
  if (!day || day.isPlaceholder) return
  const id = ev.dataTransfer.getData('id')
  const item = allEvents.value.find(e => e.id === id)
  if (!item) return

  const [type, realId] = id.split('-')
  const payload = { ...item.originalObject }

  if (type === 'tarefa') {
    payload.data = day.fullDate
  } else {
    payload.dataPagamento = day.fullDate
    if (type === 'gastoCartao') payload.tipoEdicao = 'UNICO'
  }

  const endpoint = type === 'gastoCartao' ? 'gastos-cartao' : `${type}s`
  try {
    await axios.put(`${apiBaseUrl}/${endpoint}/${realId}`, payload, authConfig())
    await fetchAllData()
  } catch (e) {
    alert('Erro ao mover evento')
  }
}

const createCalendarEvent = e => ({
  start: e.date,
  end: e.date,
  summary: e.title,
  description: e.description,
  allDay: true
})

const addToGoogleCalendar = e => {
  const url = new URL('https://www.google.com/calendar/render')
  const dateStr = e.date.toISOString().replace(/-|:|\.\d+/g, '').slice(0, 8)
  url.searchParams.append('action', 'TEMPLATE')
  url.searchParams.append('text', e.title)
  url.searchParams.append('dates', `${dateStr}/${dateStr}`)
  url.searchParams.append('details', e.description)
  window.open(url.toString(), '_blank')
}

const addToAppleCalendar = e => {
  const cal = ical({ name: 'ControlEase' })
  cal.createEvent(createCalendarEvent(e))
  const blob = new Blob([cal.toString()], { type: 'text/calendar;charset=utf-8' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${e.title}.ics`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const onDocClick = e => {
  if (openPicker.value && pickerRef.value && !pickerRef.value.contains(e.target)) {
    openPicker.value = false
  }
}

onMounted(() => {
  fetchAllData()
  document.addEventListener('click', onDocClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocClick)
})
</script>

<style scoped>
.font-sans {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-fade-enter-active,
.scale-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.scale-fade-enter-from,
.scale-fade-leave-to {
  opacity: 0;
  transform: scale(0.95) translateY(-10px);
}

.slide-up-mobile-enter-active,
.slide-up-mobile-leave-active {
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;
}

.slide-up-mobile-enter-from,
.slide-up-mobile-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@media (min-width: 1024px) {

  .slide-up-mobile-enter-active,
  .slide-up-mobile-leave-active {
    transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .slide-up-mobile-enter-from,
  .slide-up-mobile-leave-to {
    transform: translateX(100%);
    opacity: 1;
  }
}

.custom-scroll::-webkit-scrollbar {
  width: 4px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.dark .custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
}

.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>